import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  ISearchAzureSavingsPlanOrders,
  IAzureSavingsPlanOrders,
} from '../../../services/azure/azureSavingsPlanOrders/azureSavingsPlanOrders.model';
import azureSavingsPlanOrdersService from '../../../services/azure/azureSavingsPlanOrders/azureSavingsPlanOrders.service';

// Asynchronous thunk action

export const searchAzureSavingsPlanOrders = createAsyncThunk(
  'searchAzureSavingsPlanOrders',
  async (searchParam?: ISearchAzureSavingsPlanOrders) => {
    const response = await azureSavingsPlanOrdersService
      .searchAzureSavingsPlanOrders(searchParam)
      .then((res) => {
        return res.body;
      });
    return response.data;
  }
);

export const getAzureSavingsPlanOrdersById = createAsyncThunk(
  'getAzureSavingsPlanOrdersById',
  async (id: number) => {
    const response = await azureSavingsPlanOrdersService.getAzureSavingsPlanOrdersById(id).then((res) => {
      return res.body;
    });
    return response.data;
  }
);

export const saveAzureSavingsPlanOrders = createAsyncThunk(
  'saveAzureSavingsPlanOrders',
  async (data: IAzureSavingsPlanOrders) => {
    const response = await azureSavingsPlanOrdersService.saveAzureSavingsPlanOrders(data).then((res) => {
      return res.body;
    });
    return response;
  }
);

export const deleteAzureSavingsPlanOrders = createAsyncThunk(
  'deleteAzureSavingsPlanOrders',
  async (id: number) => {
    const response = await azureSavingsPlanOrdersService.deleteAzureSavingsPlanOrders(id).then((res) => {
      return res.body;
    });
    return response;
  }
);
